import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/shared/auth/auth.service';

// Mesmo padrão do AppComponent. Não vem de react-bridge/language-bridge porque aquele
// módulo importa o bootstrap da folha, que importa este arquivo.
const IDIOMA_PADRAO = 'pt_BR';

/**
 * Registra o idioma padrão e reestabelece o idioma ativo da folha a partir do locale
 * persistido. Sem locale, só o padrão vale.
 */
export function inicializarHidratacaoSessao(
  authService: AuthService,
  translate: TranslateService
): () => Observable<void> {
  return () => {
    // Espelha o AppComponent: sem idioma padrão, uma folha montada sem locale persistido
    // (ex.: iframe do Sigma) não carrega dicionário nenhum e o pipe exibe as chaves cruas.
    // setDefaultLang não altera o idioma ativo.
    translate.setDefaultLang(IDIOMA_PADRAO);

    const locale = authService.getLocale();
    if (!locale || !locale.trim()) {
      // A carga do padrão não bloqueia a pintura: o pipe re-renderiza no onDefaultLangChange.
      return of(void 0);
    }
    return translate.use(locale).pipe(
      map(() => void 0),
      // Falha ao carregar o pacote de tradução não pode bloquear o bootstrap da folha.
      catchError(() => of(void 0))
    );
  };
}
